import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import {
  Box,
  Typography,
  Button,
  Grid,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { keyframes } from "@emotion/react";

import { url ,fileUploadUrl} from "../../../../constant";


// Slide animation
const slideInLeft = keyframes`
  from {
    opacity: 0;
    transform: translateX(-50px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

const IMAGE_BASE_URL = fileUploadUrl + "/HomePageuploads/";

const failureCarouselData = [
  {
    title: "Welcome to Our Platform",
    description: "Explore the future with our cutting-edge technology solutions. We provide innovative and reliable digital experiences tailored just for you.",
    image: "https://www.synova.it/wp-content/uploads/2024/11/spiral-1-slider.png",
    buttonText: "Get Started",
  },
  {
    title: "Grow With Innovation",
    description: "We help businesses thrive in the digital era with scalable and modern solutions.",
    image: "https://www.synova.it/wp-content/uploads/2024/12/spiral-sli.png",
    buttonText: "Learn More",
  },
];


const BannerCarousel = () => {
  
  const [carouselData, setCarouselData] = useState([{
    title: "Welcome to Our Platform",
    description: "Explore the future with our cutting-edge technology solutions. We provide innovative and reliable digital experiences tailored just for you.",
    image: "https://www.synova.it/wp-content/uploads/2024/11/spiral-1-slider.png",
    buttonText: "Get Started",
  },
  {
    title: "Grow With Innovation",
    description: "We help businesses thrive in the digital era with scalable and modern solutions.",
    image: "https://www.synova.it/wp-content/uploads/2024/12/spiral-sli.png",
    buttonText: "Learn More",
  },]);
  const [activeSlide, setActiveSlide] = useState(0);
  const [loading, setLoading] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    autoplay: false,
    autoplaySpeed: 3000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    beforeChange: (oldIndex, newIndex) => setActiveSlide(newIndex),
  };


  useEffect(() => {
    fetchItems();
  }, []);

  const fetchItems = () => {
    setLoading(true);
    fetch(`${url}auth/get-hero-sections`)
      .then((r) => r.json())
      .then((res) => {
        
        const data = res?.data || [];
        const mappedData = data.map((item) => ({
          title: item.title,
          description: item.subtitle,
          buttonText: item.button_text,
          buttonLink: item.button_link,
          image: `${IMAGE_BASE_URL}${item.image_path}`,
        }));
        setCarouselData(mappedData);

        console.log("get-hero-sections",data);

      })
      .catch((err)=>{
          console.error(err);
          setCarouselData(failureCarouselData);
      })
      .finally(() => setLoading(false));

  };


  return (
    <Box
      sx={{
        py: 0,
        backgroundImage: "linear-gradient(to right, #183759, #1e4b70)",
      }}
    >
      <Slider {...sliderSettings}>
        {carouselData.map((item, index) => (
          <Box key={index} py={4}>
            <Grid
              container
              spacing={2}
              alignItems="center"
              justifyContent="center"
              sx={{
                px: 2,
                backgroundColor: "transparent",
                // maxWidth: "xl",
                // width:"80%",
                margin: "auto",
                maxWidth: {
                  xs: '100%',   // mobile
                  sm: '90%',    // small screens
                  md: '100%',    // tablets
                  lg: 1300,     // desktops
                  xl: 1600
                },
              }}
            >



              <Grid item xs={12} md={6}>
                <Box
                  sx={{
                    px: { xs: 2, sm: 4, md: 6 },
                    animation: activeSlide === index ? `${slideInLeft} 1s ease` : "none",
                  }}
                >
                  <Typography
                    variant="h4"
                    fontWeight="bold"
                    gutterBottom
                    sx={{ color: "#fff" }}
                  >
                    {item.title}
                  </Typography>
                  <Typography
                    variant="body1"
                    paragraph
                    sx={{ color: "#fff" }}
                  >
                    {item.description}
                  </Typography>
                  {/* <Button variant="contained" color="primary" sx={{ color: "#fff" }}>
                    {item.buttonText}
                  </Button> */}

                  <Button
                    variant="contained"
                    color="primary"
                    sx={{ color: "#fff" }}
                    href={item.buttonLink}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {item.buttonText}
                  </Button>

                </Box>
              </Grid>

              <Grid item xs={12} md={6}>
                <Box
                  component="img"
                  src={item.image}
                  alt="Banner"
                  sx={{
                    width: "100%",
                    maxHeight: 400,
                    objectFit: "contain",
                    animation: activeSlide === index ? `${slideInLeft} 1s ease` : "none",
                    px: { xs: 2, sm: 4, md: 6 },
                  }}
                />
              </Grid>
            </Grid>
          </Box>
        ))}
      </Slider>
    </Box>
  );
};

export default BannerCarousel;
